import React, { useEffect, useContext, useState } from "react";
import "./Profile.css";
// import ProfileFeed from "../../components/feed/ProfileFeed";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import axios from "axios";
import Link from "../../components/link/Link";
import { Link as RouterLink } from "react-router-dom";
import { useParams } from "react-router";
import { AuthContext } from '../../context/AuthContext';
import { FaRegListAlt } from "react-icons/fa";
import { VscVerifiedFilled } from "react-icons/vsc";
import config from "../../config";

export default function Profile() {
  const { user: currentUser } = useContext(AuthContext);
  const [ profile, setProfile ] = useState();
  const profileUsername = useParams().username;
  const [ link, setLink ] = useState();
  const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;

  useEffect(() => {
    async function fetchUser(){
      const res = await axios.get(`${config.apiUrl}/api/users?username=${profileUsername}`);
      setProfile(res.data);
    }

    async function fetchActiveLinks(username, page) {
      const res = await axios.get(`${config.apiUrl}/links/profile/${profileUsername}?page=${page}`);
      const data = res.data;
      setLink(data[0]);
    }

    fetchUser();
    fetchActiveLinks(profile, 1);
  }, [profileUsername]);

  return (
    <>
    {profile && 
      <div className="profile">
        <div className="profiletopCenter">
          <div className="profileCover">
            <img
              className="profileCoverImg"
              src={
                profile.coverPicture
                  ? profile.coverPicture
                  : `${cloudfrontUrl}/static/nocover.png`
              }
              alt="No Profile Cover Photo"
            />

            <img
              className="profileUserImg"
              src={
                profile.profilePicture
                  ? profile.profilePicture
                  : `${cloudfrontUrl}/static/no-profile-pic.webp`
              }
              alt="No Profile Picture"
            />
          </div>
          <div className="profileInfo">
            <div className="profile-info-top">
              <h4 className="profileInfoName">
                {profile.displayName}
                {profile.isSubscribed &&
                  <VscVerifiedFilled className="verified-icon"/>
                }
                </h4>
              <span className="profileUserName">@{profile.username}</span>
              <span className="profileInfoDesc">{profile.bio}</span>
              {/* render icon if location exists */}
              {profile.location && (
                <div className="locationContainer">
                  <LocationOnOutlinedIcon className="locationIcon" />
                  <span className="profileLocation">{profile.location}</span>
                </div>
              )}
            </div>
            <RouterLink to={`/wishlist/${profile.username}`}>
              <div className="profile-wishlist-container">
                <div className="profile-wishlist-icon">
                  <FaRegListAlt />
                </div>
              </div>
            </RouterLink>
          </div>
          <hr className="profileHR" />
        </div>
        <div className="profileFeeds">
          <div className="profile-link-container">
            {(link && currentUser.username === link.creatorUsername) ? (
              <Link link={link} />
            ) : (
              <p className="no-active-links">Subscribe to see this user&apos;s link</p>
            )}
          </div>

            {/* {userActiveLinks === 0 && (
            {/* )} */}
        </div>
      </div>
    
    }
    </>
  );
}
